import { useEffect, useState } from "react";
import { isBrowser } from "../helpers/common";

export interface DefaultWindow {
  scrollY: number
  innerWidth: number;
  innerHeight: number;
  addEventListener: () => null;
  removeEventListener: () => null;
  setTimeout: () => null;
  location: {
    href: string;
    origin: string;
    hash: string;
    search: string;
    reload: () => void;
    pathname: string;
  };
  atob: (data: string) => string;
  sessionStorage: Storage | null;
  localStorage: Storage | null;
  scrollTo: () => void;
}

export const defaultWindow: DefaultWindow = {
  innerWidth: 0,
  innerHeight: 0,
  scrollY: 0,
  addEventListener: () => {
    return null;
  },
  removeEventListener: () => {
    return null;
  },
  setTimeout: () => {
    return null;
  },
  atob: () => {
    return '';
  },
  location: {
    href: import.meta.env.VITE_URL || '',
    origin: import.meta.env.VITE_URL || '',
    search: "",
    hash: '',
    reload: () => {},
    pathname: '',
  },
  sessionStorage: null,
  localStorage: null,
  scrollTo: () => {}
};

export default function useWindow(): Window | DefaultWindow {
  const [_window, setWindow] = useState<Window | DefaultWindow>(defaultWindow);

  useEffect(() => {
    if (isBrowser() && !!window) {
      setWindow(window);
    }
  }, []);

  return _window;
}
